import React from 'react'
import {actions as salesActions, selectors as salesSelectors} from '../../../Ducks/opportunity';
import {selectors as accountSelectors} from '../../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {fetchGet} from '../../../API/util';
import GridElement from '../../Common/GridElement';
import {Button} from '@mui/material';
import EditTable from '../../Common/EditTable';
import {cloneDeep, isEmpty} from 'lodash';

const makeHeader = (title) => {
    let _title = "";
    if (title.includes(".")) {
        _title = title.split(".")[1].split("_");
    } else {
        _title = title.split("_");
    }
    return _title.join(" ");
}

const makeAccessor = (key) => {
    if (key.includes(".")) {
        return key.split(".")[1];
    } else {
        return key
    }
}

const OpportunityGrid = (props) => {
    const {navigate} = props;
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [rowsCount, setRowsCount] = React.useState(0);
    const [filters, setFilters] = React.useState([]);
    const [controlledPageIndex, setControlledPageIndex] = React.useState(0);
    const [isOpen, setIsOpen] = React.useState(false);
    const [_exportQuery, setExportQuery] = React.useState(false);
    const [cols, setCols] = React.useState(JSON.parse(localStorage.getItem("user")).tableSettings.opportunities.columns.map(key => ({
        column: key,
        accessor: makeAccessor(key),
        minWidth: 150,
        Header: makeHeader(key === 'opportunity_sub_source' ? 'opportunity_subsource' : key),
        filter: 'fuzzyText'
    })));
    const fetchIdRef = React.useRef(0);

    const fetchData = React.useCallback(({pageSize, pageIndex, sortBy, filters, columns}) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        // even a server. But for this example, we'll just fake it.

        // Parse columns
        const _columns = columns.map((item) => item.column)

        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        // Set the loading state
        setLoading(true)

        // Check filter data
        let query = "", api = "", sort = "", filterPrefix = "";
        filters.forEach((item, index) => {
            const _filterColumn = columns.filter((column) => column.accessor === item.id);
            if (_filterColumn[0].column.includes(".")) {
                filterPrefix = _filterColumn[0].column.split(".")[0]
            } else {
                filterPrefix = "opportunities"
            }
            query = query + `&contains[${filterPrefix}.${item.id}]=${item.value}`
        });

        // Check sorting
        if (sortBy.length) {
            let _sortByPrefix = "", _sortByColumn = columns.filter((column) => column.accessor === sortBy[0].id);
            if (_sortByColumn[0].column.includes(".")) {
                _sortByPrefix = _sortByColumn[0].column.split(".")[0]
                _sortByPrefix = `${_sortByPrefix}.`
            }
            sort = `&sortBy=${sortBy[0].desc ? "-" : ""}${_sortByPrefix}${sortBy[0].id}`;
        }

        api = `/opportunities?results=${pageSize}&columns=${_columns}&offset=${pageIndex + 1}${query}${sort}`

        fetchGet(api).then(opportunities => {
            if (fetchId === fetchIdRef.current && opportunities) {
                const _opportunities = cloneDeep(opportunities);
                const jobs = opportunities.data.related_objects["jobs"]
                const products = opportunities.data.related_objects["products"]

                if (!isEmpty(opportunities.data.related_objects)) {
                    _opportunities.data.main.forEach((opportunity, index) => {
                        if (products && !isEmpty(products[opportunity.product_id])) {
                            const _product_obj = cloneDeep(products[opportunity.product_id])
                            delete _product_obj["product_id"]
                            Object.assign(opportunity, _product_obj);
                        }

                        if (jobs && !isEmpty(jobs[opportunity.job_id])) {
                            const _job_obj = cloneDeep(jobs[opportunity.job_id])
                            delete _job_obj["job_id"]
                            Object.assign(opportunity, _job_obj);
                        }
                    });
                }

                setData(_opportunities.data.main);
                setPageCount(opportunities.data.offset.highest_offset);
                setRowsCount(opportunities.data.offset.rows_count);
                setExportQuery(`/opportunities?&columns=${_columns}${query}${sort}`)
                setLoading(false);
            }
        }).catch((_error) => {
            setLoading(false);
        })
    }, []);

    const resetFilters = React.useCallback(() => setFilters([]), [setFilters]);

    const handleRowClick = (row) => {
        navigate("/opportunities/id/" + row.original.opportunity_id);
    }

    const handleClose = () => {
        setIsOpen(false);
    }

    const exportRows = () => {
    }

    return (
        <>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h2 className="page-title">Opportunities</h2>
                <div>
                    <Button variant="outlined" color='primary' onClick={exportRows}
                            sx={{marginRight: '5px'}}>Export</Button>
                    <Button variant="outlined" color='primary' onClick={() => setIsOpen(true)}>Edit Table</Button>
                </div>
            </div>

            <GridElement
                columns={cols}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                handleRowClick={handleRowClick}
                initialSortBy="opportunity_id"
            />

            <EditTable
                open={isOpen}
                onClose={handleClose}
                columns={["opportunities", "products", "jobs"]}
                table="opportunities"
                setColumns={setCols}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    isLoading: salesSelectors.isLoading(state),
    errorMessage: salesSelectors.errorMessage(state),
    opportunities: salesSelectors.opportunities(state),
    user: accountSelectors.user(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getOpportunities: salesActions.getOpportunities,
    },
    dispatch);

function WithNavigate(props) {
    let navigate = useNavigate();
    return <OpportunityGrid {...props} navigate={navigate}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);